import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/sections/HeroSection';
import QuickLinksSection from '../components/sections/QuickLinksSection';
import StatsSection from '../components/sections/StatsSection';
import QuickStartSnippetSection from "../components/sections/QuickStartSnippetSection";

const HomePage = () => {
    return (
        <>
            <Helmet>
                <title>Netikash Developer Portal - Documentation API</title>
                <meta name="description" content="Documentation complète de l'API Netikash. Intégrez les paiements mobiles en quelques minutes avec nos guides, exemples de code et playground interactif." />
                <meta name="keywords" content="Netikash, API, paiement mobile, documentation, intégration, développeur" />
                <meta property="og:title" content="Netikash Developer Portal" />
                <meta property="og:description" content="Documentation complète de l'API Netikash pour intégrer les paiements mobiles" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 dark:from-slate-950 dark:to-slate-900 transition-colors">
            <HeroSection />
            <QuickLinksSection />
            <QuickStartSnippetSection />
            <StatsSection />
            </div>
        </>
    );
};

export default HomePage;